import React, { useState } from 'react'
import { useTranslation } from 'i18n'
// @ts-expect-error SCSS modules are untyped in this project
import * as styles from '../product-scan.module.scss'

// The accessibility path, not an optional extra (AC): offered whenever the camera is unavailable
// or denied, and posts to the same /product-scan/scan endpoint as a camera-decoded code.
const ManualEntryForm = ({ onSubmit }: { onSubmit: (code: string) => void }) => {
  const { t } = useTranslation('productScan')
  const [value, setValue] = useState('')

  return (
    <form
      className={styles.manualEntry}
      onSubmit={e => {
        e.preventDefault()
        if (value.trim()) onSubmit(value.trim())
      }}
    >
      <label htmlFor="product-scan-manual-code">{t('manualEntryLabel')}</label>
      <input
        id="product-scan-manual-code"
        className={styles.manualEntryInput}
        type="text"
        inputMode="numeric"
        placeholder={t('manualEntryPlaceholder')}
        value={value}
        onChange={e => setValue(e.target.value)}
      />
      <button type="submit" className={styles.cta} disabled={!value.trim()}>
        {t('manualEntrySubmit')}
      </button>
    </form>
  )
}

export default ManualEntryForm
